export class CustomOrder {
    constructor({
        id,
        department,
        storeId,
        items,
        customerName,
        customerPhone,
        pickupDate,
        pickupTime,
        pickupDateTimeUtc,
        createdAt,
        status = 'created',
        paid = false,
        delivered = false
    }) {
        this.id = id;
        this.department = department;
        this.storeId = storeId || '';
        this.items = items;
        this.customerName = customerName;
        this.customerPhone = customerPhone;
        this.pickupDate = pickupDate;
        this.pickupTime = pickupTime;
        this.pickupDateTimeUtc = pickupDateTimeUtc;
        this.createdAt = createdAt;
        this.status = status || 'pending';
        this.paid = paid || false;
        this.delivered = delivered || false;
    }

    toJson() {
        return {
            department: this.department,
            store_id: this.storeId,
            items: this.items,
            customerName: this.customerName,
            customerPhone: this.customerPhone,
            pickupDate: this.pickupDate,
            pickupTime: this.pickupTime,
            pickupDateTimeUtc: this.pickupDateTimeUtc,
            createdAt: this.createdAt,
            status: this.status,
            paid: this.paid,
            delivered: this.delivered,
        };
    }

    static fromFirebase(doc) {
        const data = doc.data();
        return new CustomOrder({
            id: doc.id,
            department: data.department,
            storeId: data.store_id || data.store || '',
            items: data.items || [],
            customerName: data.customerName,
            customerPhone: data.customerPhone,
            pickupDate: data.pickupDate,
            pickupTime: data.pickupTime,
            pickupDateTimeUtc: data.pickupDateTimeUtc,
            createdAt: data.createdAt,
            status: data.status || 'pending',
            paid: data.paid || false,
            delivered: (data.delivered !== undefined ? data.delivered : data.customerNotified) || false,
        });
    }
}
